import React, { useState } from 'react';
import ButtonComponent from '@/components/ButtonComponent';
import TextComponent from '@/components/TextComponent';
import styled from 'styled-components';
import TimeSelectItem from '../TimeSelectItem';
import { formatDutyTimeForSet, FormattedDutyType } from '@/utils/time';
import GlobalAlert from '@/components/GlobalAlert';
import usePharmacyQuery from '@/hooks/pharmacy/usePharmacyQuery';
import theme from '@/styles/theme';

export interface SetDutyType {
  weekDay: number;
  value: number;
  type: 'openHour' | 'openMinute' | 'closeHour' | 'closeMinute';
}

interface Props {
  dutyTime: Array<FormattedDutyType>;
  setDutyModal: (on: boolean) => void;
}

const DutyTime = (props: Props) => {
  const { dutyTime, setDutyModal } = props;
  const [time, setTime] = useState<Array<FormattedDutyType>>(dutyTime);
  const { dutyTimeMutation } = usePharmacyQuery();

  const onChangeSelect = (data: SetDutyType) => {
    const { weekDay, type, value } = data;
    const newDay = time?.map((day: FormattedDutyType) => {
      if (weekDay === day.weekDay) {
        day[type] = value;
      }
      return day;
    });
    setTime(newDay);
  };

  const onClickHoliday = (weekDay: number) => {
    const newDay = time?.map((day: FormattedDutyType) => {
      if (weekDay === day.weekDay) {
        day.isClosed = !day.isClosed;
      }
      return day;
    });
    setTime(newDay);
  };

  const submitCheck = () => {
    GlobalAlert.show({
      title: '운영시간을 수정하시겠습니까?',
      buttons: [{ text: '확인', onClick: onSubmit }],
      clickOverlayToClose: true
    });
  };

  const onSubmit = async () => {
    GlobalAlert.hide();
    const newTime = formatDutyTimeForSet(time);
    const res = await dutyTimeMutation.mutateAsync(newTime);

    if (res) {
      setDutyModal(false);
      GlobalAlert.show({
        title: '수정이 완료되었습니다.'
      });
    }
  };

  return (
    <DutyTimeWrapper>
      <ModalTop>
        <TopText>운영 시작</TopText>
        <TopText>운영 종료</TopText>
      </ModalTop>
      <ModalMiddle>
        {time?.map(item => (
          <TimeSelectItem
            key={item.weekDay}
            dutyTime={item}
            onChangeSelect={onChangeSelect}
            onClickHoliday={onClickHoliday}
          />
        ))}
      </ModalMiddle>
      <ModalBottom>
        <ButtonComponent
          bgColor={theme.DF_COLOR.GREEN500}
          text={'수정 완료'}
          padding={'1rem 8rem'}
          onClick={submitCheck}
        />
      </ModalBottom>
    </DutyTimeWrapper>
  );
};

export default DutyTime;

const DutyTimeWrapper = styled.div`
  margin: 40px 50px;
`;

const ModalTop = styled.div`
  display: flex;
  margin-bottom: 22px;
  margin-left: 75px;
  margin-right: 100px;
  > * {
    flex: 1;
    text-align: center;
  }
`;

const TopText = styled(TextComponent)`
  font-size: 22px;
  font-weight: 600;
`;

const ModalMiddle = styled.div`
  margin-bottom: 35px;
`;
const ModalBottom = styled.div`
  text-align: center;
`;
